(async () => {

  const { default: Swiper, Autoplay, EffectSlide, EffectFade } = await import("swiper");

  Swiper.use([
    Autoplay,
    EffectSlide,
    EffectFade
  ]);

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      document.body.classList.add('announcement-bar-visible');
      this.swiperElement = this.querySelector('[data-swiper-announcement-bar]');
      this.swiperOptions = {
        loop: true,
        autoplay: true,
        slidesPerView: 1,
        direction: 'horizontal'
      }

      // Check if we have extra options on the HTML
      if (this && this.dataset && this.dataset.options) {
        const jsonOptions = JSON.parse(this.dataset.options);

        if (jsonOptions) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...jsonOptions
          }
        }
      }

      this.init();
    }
    init() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      if(Shopify.designMode && this.swiperInstance) {

        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });

        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update();
          this.handleThemeEditorEvents(event);
        });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
    }

  }

  window.AnnouncementBar = AnnouncementBar;

  customElements.define('announcement-bar', AnnouncementBar);

})();
